<template>
  <v-card class="maxh-100 mx-0 d-flex flex-column white" style="overflow-y: hidden!important;min-height: 0;;">
<div class="search-results-header">
<div class=" pa-4 elevation-2 transparent d-flex align-center">

  <v-text-field
    style="flex: 1 1 auto;"
    class="mr-2"
    ref="searchOverlayTextField"
    v-model="localSearchtext"
    @keyup="$emit('update:searchtext', $event, localSearchtext)"
    solo
    outlined
    prepend-inner-icon="mdi-magnify"
    hide-details
  >
      <template slot="append">
      <v-icon @click="clearSearch()">clear</v-icon>
      <v-progress-circular indeterminate v-show="loading"></v-progress-circular>
    </template>
  </v-text-field>

  <div style="flex: 0 0 auto;">
    <v-btn icon @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>

</div>

    <!-- SUBHEADER (Pagination + Info) -->
    <div v-if="$vuetify.breakpoint.smAndUp" class="mx-2" >
      <v-subheader style="padding: 0px;">

        <v-list-item-content class="text-center">
          <v-list-item-title class="grey--text">
            {{ getSearchRangeText }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ getResultsForText }}
          </v-list-item-subtitle>
        </v-list-item-content>


      </v-subheader>
    </div>
</div>
    <div class="flex-grow-1 overflow-y-auto">

    <!-- RESULTS -->

    <lazyTileGrid v-if="results.length > 0" @loadMore="handleLoadMore"  :items="getItems(results)" :itemsCount="totalres" ></lazyTileGrid>

    </div>

  </v-card>
</template>

<script>
import { get } from 'jquery';
import ResultCard from './ResultCard'
import lazyTileGrid from './lazyTileGrid'
import {filterRelatedAnnotationsByHighlight} from '@/utils/helpers'
import { HighLightTranslator, serviceFields } from '@/utils/constants';

export default {
  name: 'SearchOverlay',
  components: {
    ResultCard,
    lazyTileGrid
  },
  props: {
    results: Array,
    loading: Boolean,
    searchtext: String,
    searchPack: Number,
    totalres: Number
  },
  data () {
    return {
      localSearchtext: this.searchtext
    }
  },
  methods: {
    cleanHighlight(html) {
      if (!html) return "";
      const spans = [...html.matchAll(/<span[^>]*>[\s\S]*?<\/span>/g)];
      if (spans.length === 0) return html;

      const firstSpan = spans[0];
      const lastSpan = spans[spans.length - 1];
      const firstSpanIndex = firstSpan.index;
      const lastSpanEndIndex = lastSpan.index + lastSpan[0].length;

      let vorSpan = html.slice(0, firstSpanIndex);
      let zwischenSpan = html.slice(firstSpanIndex, lastSpanEndIndex);
      let nachSpan = html.slice(lastSpanEndIndex);

      const firstGt = vorSpan.indexOf(">");
      if (firstGt !== -1) vorSpan = vorSpan.slice(firstGt + 1);

      const lastLt = nachSpan.lastIndexOf("<");
      if (lastLt !== -1) nachSpan = nachSpan.slice(0, lastLt + 1);

      zwischenSpan = zwischenSpan.replace(/mso-[a-zA-Z\-]+:[^;"']+;?/g, "");

      return vorSpan + zwischenSpan + nachSpan;
    },
    getHighlighted(item) {
      this.$log.debug("getHighlighted", item);
      let res = "";
      if (item.highlight) {
        const limit = 3;
        let iteration = 1;
        for (let key in item.highlight) {
          if (!(key.includes(".search") || serviceFields.includes(key))) {
            if (iteration > limit) break;
            iteration += 1;

            let keyText = HighLightTranslator[key] || key;
            // Wir nutzen die selbe cleane Logik, formatieren es aber kompakter
            let cleanText = this.cleanHighlight(item.highlight[key][0]);
            res += `<div class='text-caption mb-1'><strong>${keyText}:</strong> ${cleanText}</div>`;
          }
        }
      }

      return res;
    },
    getItems(results) {
      var items = []
      for (const result of results) {
        var item = result._source
        item.highlighted = this.getHighlighted(result)
        const annotations = filterRelatedAnnotationsByHighlight(result, this.$store.getters.getAnnotations)
        for (const annotation of annotations) {
          if (annotation.w3c && typeof annotation.w3c === 'string') {
              try {
                annotation.w3c = JSON.parse(annotation.w3c);
              } catch (e) {
                console.error("Fehler beim Parsen der Annotation:", e);
              }
            }
          annotation.w3c.motivation = "highlight"
        }
        item.highlightedAnnotations = annotations
        items.push(item)
      }
      console.log("getItems", items);
      return items

    },
    handleLoadMore(visibleCount, batchSize) {
        this.$log.debug("handleLoadMore triggered", batchSize)
        // Leite die batchSize weiter, die vom Grid kommt
        this.$emit('addnext', batchSize);
      },
    close () {
      this.$emit('close')
    },
    getNextResults() {
      this.$log.debug("getNextResults truggered")
      this.$emit('addnext')
    }
  },
computed: {
  getResultsForText() {
    if (!this.searchtext) {
      return "Please enter a search term."
    }
    return 'Results for: ' + this.searchtext
  },
  getSearchRangeText() {
    if (this.totalres > 0) {
      return `${this.results.length} Results of ${this.totalres} Shown`
    }
    return ""
  },
},
mounted() {
  this.$log.debug("SearchOverlay mounted");
  this.$nextTick(() => {
    if (this.$refs.searchOverlayTextField) {
      this.$refs.searchOverlayTextField.focus()
      this.$log.debug("focus on input")
    }
  })

},
watch: {
  results() {
    this.$emit('update:results', this.results)
  },
  localSearchtext() {
    this.$log.debug("localSearchtext:", this.localSearchtext)
  }
}
}
</script>
<style scoped>
  .search-results-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: white;   /* WICHTIG */
}
</style>